export default "/images/vendor/flag-icon-css/flags/1x1/sv.svg?f4b3314001ea3a7cf1d0a98c254d8cd3";